export default __webpack_public_path__ + "static/media/destaque-ruff.87b14361.jpg";